import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  type?: 'website' | 'article';
  image?: string;
  url?: string;
  schema?: object;
}

const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  type = 'website', 
  image = 'https://spinharvester.com/images/logo.webp',
  url = 'https://spinharvester.com',
  schema 
}) => {
  const defaultSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'SpinHarvester',
    url: 'https://spinharvester.com',
    description: 'Comprehensive UK casino reviews and exclusive offers',
    publisher: {
      '@type': 'Organization',
      name: 'SpinHarvester',
      logo: {
        '@type': 'ImageObject',
        url: 'https://spinharvester.com/images/logo.webp'
      }
    }
  };

  const finalSchema = schema || defaultSchema;
  const fullTitle = `${title} | SpinHarvester`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="SpinHarvester" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(finalSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;

